// extracted by mini-css-extract-plugin
export default {"jobCount":"Ac9M1","noResults":"Jrk9t","filterArea":"pn3PT","search":"hYLsl","soloReportTable":"sk56N"};